import React from 'react';
import { View, StyleSheet, Platform, useWindowDimensions } from 'react-native';
import LocationSummaryMobileCardList from '../../components/LocationSummaryMobileCardList';
import LocationSummaryTable from '../../components/LocationSummaryTable';
import { LocationDetailsParams } from './perfectTruckKpiApi';

interface LocationSummaryProps {
  filterParams?: LocationDetailsParams;
}

const LocationSummary: React.FC<LocationSummaryProps> = ({ filterParams = {} }) => {
  const { width } = useWindowDimensions();
  const isMobileIos = Platform.OS === 'ios' && width < 768;

  return (
    <View style={styles.container}>
      {isMobileIos
        ? <LocationSummaryMobileCardList filterParams={filterParams} />
        : <LocationSummaryTable filterParams={filterParams} />}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    width: '100%',
  },
});

export default LocationSummary;
